import React, { useEffect, useState } from "react";
import SecondLayout from "../../../layouts/SecondLayout";
import Cookies from "js-cookie";
import Story from "../home/Story";
import Testimonials from "../Testimonials/Testimonials";
import { useNavigate } from "react-router-dom";
import { Variables } from "../../../variables";

const GccProduct = () => {
  const navigate = useNavigate();

  const [language, setLanguage] = useState(Cookies.get("RashaLang") || "ar");
  const [content, setContent] = useState([]);

  // loader + error
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [videoFailed, setVideoFailed] = useState(false);

  // watch language cookie
  useEffect(() => {
    const interval = setInterval(() => {
      const currentLang = Cookies.get("RashaLang") || "ar";
      setLanguage((prevLang) => (prevLang !== currentLang ? currentLang : prevLang));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const directionClass = language === "en" ? "text-left" : "text-right";

  const testimonialsData = {
    en: [
      {
        name: "Jennifer Lewis",
        image: "/assets/images/testimonials/jennifer.jpg",
        message:
          "It was wonderful! Never felt my skin cleaner before! Thanks for recommending magical lumispa",
      },
      {
        name: "Alicia Heart",
        image: "/assets/images/testimonials/alicia.jpg",
        message:
          "Simply stunned with fast results. Worth the money. Thanks Rasha!",
      },
      {
        name: "Juana Paterson",
        image: "/assets/images/testimonials/juana.jpg",
        message:
          "Love it! Easy to use and noticed the difference on my skin from the first week",
      },
    ],
    ar: [
      {
        name: "جينيفر لويس",
        image: "/assets/images/testimonials/jennifer.jpeg",
        message:
          "لقد كانت تجربة رائعة! لم أشعر من قبل أن بشرتي أنظف! شكرًا على التوصية بجهاز لوميسبا السحري",
      },
      {
        name: "أليشيا هارت",
        image: "/assets/images/testimonials/alicia.jpeg",
        message: "مندهشة من النتائج السريعة. تستحق المال. شكرًا رشا!",
      },
      {
        name: "جوانا باترسون",
        image: "/assets/images/testimonials/juana.jpeg",
        message:
          "أحببته! سهل الاستخدام ولاحظت الفرق على بشرتي من الأسبوع الأول",
      },
    ],
  };

  const sectionTitle = language === "ar" ? "ماذا يقول عملاؤنا؟" : "What Our Customers Say";

  const buttonNavigation = () => navigate("/beauty-blog");

  // fetch content (show ONLY loader/error without layout; show layout after)
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const url =
          Variables.API_URL +
          "Rasha/Client/Page/2?isEnglish=" +
          (language === "en");

        const response = await fetch(url, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          signal: controller.signal,
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result?.message || "Failed to fetch content");
        }

        if (isMounted) setContent(Array.isArray(result) ? result : []);
      } catch (err) {
        if (isMounted && err.name !== "AbortError") {
          setError(err.message || "Something went wrong");
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchData();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [language]);

  // helpers
const slugify = (s = "") =>
  s
    .toString()
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9\u0600-\u06FF-]/g, "")
    .replace(/-+/g, "-");

  // --- Loader (no layout) ---
  if (loading) {
    return (
      <div style={styles.loaderWrap}>
        <div style={styles.spinner} />
      </div>
    );
  }

  // --- Error (no layout) ---
  if (error) {
    return <div style={styles.errorBox}>{error}</div>;
  }

  // --- Main UI (with layout AFTER loading) ---
  return (
    <SecondLayout>
      <div className="container product-container my-5">
        <div className="row justify-content-center" dir={language === "ar" ? "rtl" : "ltr"}>
          {content.map((c, index) => {
            const key = c.WidgetId ?? `${c.WidgetTypeId}-${c.WidgetValue?.Id ?? index}`;
            const typeId = parseInt(c.WidgetTypeId, 10);

            if (typeId === 5) {
              const name = language === "en" ? c?.WidgetValue?.Name : c?.WidgetValue?.NameAr;
              const body = language === "en" ? c?.WidgetValue?.Body : c?.WidgetValue?.BodyAr;
              const img = Variables.API_PUBLISHED + (c?.WidgetValue?.ImageUrl || "");
              const slug = slugify(c?.WidgetValue?.Name || "");
              const id = c?.WidgetValue?.Id ?? 0;

              return (
                <div
                  key={key}
                  onClick={() => navigate(`/${slug}/${id}`)}
                  className="col-lg-3 col-md-6 col-sm-12 mb-4 text-center cursor-pointer"
                >
                  <img
                    src={img}
                    alt={name || "Product"}
                    className="img-fluid mb-3"
                    style={{ width: "100%" }}
                  />
                  <h4 className="fw-bold" style={{ fontFamily: "Libre Caslon Display, serif" }}>
                    {name}
                  </h4>
                  <p className="text-muted text-justify">{body}</p>
                </div>
              );
            }

            if (typeId === 1) {
              return (
                <Story
                  key={key}
                  storyContent={
                    language === "en"
                      ? (c?.WidgetValue?.Body || "").split("\n")
                      : (c?.WidgetValue?.BodyAr || "").split("\n")
                  }
                  language={language}
                  storyContentAR={(c?.WidgetValue?.BodyAr || "").split("\n")}
                  storyContentEN={(c?.WidgetValue?.Body || "").split("\n")}
                  storyTitle={
                    language === "en" ? c?.WidgetValue?.Title : c?.WidgetValue?.TitleAr
                  }
                  buttonText={
                    language === "en" ? c?.WidgetValue?.ButtonText : c?.WidgetValue?.ButtonTextAr
                  }
                  directionClass={directionClass}
                  bodyClass="justify-content-center"
                  image={Variables.API_PUBLISHED + (c?.WidgetValue?.ImageUrl || "")}
                  buttonNavigation={buttonNavigation}
                />
              );
            }

            if (typeId === 4) {
              const videoUrl = c?.WidgetValue?.VideoUrl || "";
              return (
                <div key={key} className="beauty-selector-container">
                  {!videoFailed ? (
                    <iframe
                      className="background-video"
                      src={videoUrl}
                      frameBorder="0"
                      allow="autoplay; fullscreen"
                      allowFullScreen
                      title="Skincare Background"
                      onError={() => setVideoFailed(true)}
                    />
                  ) : (
                    <div className="background-fallback" />
                  )}
                </div>
              );
            }

            return null;
          })}
        </div>
      </div>

      <Testimonials
        testimonialsData={testimonialsData}
        language={language}
        sectionTitle={sectionTitle}
      />
    </SecondLayout>
  );
};

const styles = {
  loaderWrap: {
    minHeight: "60vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  spinner: {
    width: 48,
    height: 48,
    border: "4px solid rgba(0,0,0,0.1)",
    borderTopColor: "#000",
    borderRadius: "50%",
    animation: "spin 0.9s linear infinite",
  },
  errorBox: {
    margin: 16,
    padding: "12px 16px",
    border: "1px solid #f3c2c2",
    background: "#fff5f5",
    color: "#b00020",
    borderRadius: 8,
  },
};

// inject keyframes (once, unique id for this page)
if (typeof document !== "undefined" && !document.getElementById("gccproduct-spin-kf")) {
  const styleEl = document.createElement("style");
  styleEl.id = "gccproduct-spin-kf";
  styleEl.innerHTML = `@keyframes spin { to { transform: rotate(360deg); } }`;
  document.head.appendChild(styleEl);
}

export default GccProduct;
